<div
  class="accordion"
  [ngClass]="forordnandeStyle() ? 'forordnande-modal-accordian' : ''"
  #accordionContainer
>
  <button
    class="accordion-header"
    [ngClass]="{
      'forordnande-modal-header': forordnandeStyle(),
      alwaysOpen: alwaysOpen(),
    }"
    (click)="toggleCollapse()"
    [class.has-subtitle]="subTitle()"
    [disabled]="disabled()"
    [class.hover]="hover()"
    [attr.aria-expanded]="isOpenSignal()"
    [attr.aria-controls]="'accordion-' + id()"
    [attr.aria-invalid]="error()"
    [attr.aria-label]="title()"
  >
    <div class="header-text">
      <h2 class="heading-size-5">{{ title() }}</h2>
      @if (subTitle()) {
        <p [class.success]="success()" [class.error]="error()" class="subtitle">
          @if (success()) {
            <lib-icon
              name="check-circle"
              class="status-icon success"
              size="x-small"
              aria-hidden="true"
            ></lib-icon>
          } @else if (error()) {
            <lib-icon
              name="alert-circle"
              class="status-icon error"
              size="x-small"
              aria-hidden="true"
            ></lib-icon>
          }
          <span>{{ subTitle() }}</span>
        </p>
      }
    </div>
    @if (!alwaysOpen()) {
      @if (isOpenSignal()) {
        <lib-icon
          name="minus"
          class="collapse-icon"
          aria-hidden="true"
        ></lib-icon>
      } @else {
        <lib-icon
          name="plus"
          class="collapse-icon"
          aria-hidden="true"
        ></lib-icon>
      }
    }
  </button>
  <div
    [libCollapse]="!isOpenSignal()"
    [attr.id]="'accordion-' + id()"
    (visible)="isVisible.set($event)"
  >
    @if (isVisible() || alwaysRender() || alwaysOpen()) {
      <div
        class="accordion-body position-relative"
        [ngClass]="
          bodyWidth() === 'small'
            ? 'col-lg-9'
            : bodyWidth() === 'medium'
              ? 'col-lg-11'
              : undefined
        "
        [ngClass]="forordnandeStyle() ? 'forordnande-modal-body' : ''"
      >
        @if (previewMode()) {
          <div class="preview-overlay"></div>
        }
        <ng-content></ng-content>
      </div>
    }
  </div>
</div>
